import * as actions from '../actions';
import { deepCloneObj } from '../../utils/utils';
import { loadMoreSize, allSpecialFilterKey, SORT_DEFAULT } from '../const';
import { produce } from 'immer';

// The state of the page itself

let initialState = {
  filtersVisibility: false,
  // Recipies State
  recipes: [],
  canLoadMoreRecipes: true,
  selectedDishType: allSpecialFilterKey,
  appliedRecipeFilters: {
    serving_size: null,
    featured: [],
    max_calories: null,
    dietary: [],
    max_cooking_time: null,
    protein: [],
    spicy_level: [],
    favorite: [],
  },
  selectedRecipeFilters: {
    featured: [],
    serving_size: null,
    max_calories: null,
    dietary: [],
    max_cooking_time: null,
    protein: [],
    spicy_level: [],
    favorite: [],
  },
  dishTypeCount: {},
  recipesTotalCount: null,
  //Skus StateGET_FILTERED_SKUSGET_FILTERED_SKUS
  skus: [],
  canLoadMoreSkus: true,
  selectedSkuCategory: allSpecialFilterKey,
  appliedSkuFilters: {
    featured: [],
    dietary: [],
    protein: [],
    occasion: [],
    spicy_level: [],
  },
  selectedSkuFilters: {
    featured: [],
    dietary: [],
    protein: [],
    occasion: [],
    spicy_level: [],
  },
  categoryCount: {},
  skusTotalCount: null,
  dietaryPreferences: {},
  searchText: '',
  appliedSearchText: '',
  sorting: SORT_DEFAULT, // sort_by_default
  // the tagOptions are dependend on db tags data so, unlike the other
  // filter categories they cannot be hardcoded as consts.
  tagOptions: {},
  tagOptionsOrder: [],
};

const filters = (state = initialState, action) => {
  let newState = deepCloneObj(state);
  let { selectedSkuFilters } = newState;
  let { selectedRecipeFilters } = newState;
  switch (action.type) {
    // SKUS
    case actions.SELECT_SKU_CATEGORY:
      return Object.assign({}, newState, {
        selectedSkuCategory: action.category,
      });

    case actions.TOGGLE_SKU_FILTER:
      let afc = action.filterCategory;
      if (Array.isArray(selectedSkuFilters[afc])) {
        if (selectedSkuFilters[afc].includes(action.filter)) {
          selectedSkuFilters[afc] = selectedSkuFilters[afc].filter(
            (filter) => filter != action.filter
          );
        } else {
          selectedSkuFilters[afc].push(action.filter);
        }
      } else {
        selectedSkuFilters[afc] =
          selectedSkuFilters[afc] === action.filter ? null : action.filter;
      }
      return newState;

    case actions.APPLY_SKU_FILTERS:
      newState.appliedSkuFilters = deepCloneObj(newState.selectedSkuFilters);
      newState.filtersVisibility = false;
      return newState;

    case actions.CLEAR_SKU_FILTERS:
      const skuCat = action.category;
      if (skuCat !== null) {
        newState.selectedSkuFilters[skuCat] = deepCloneObj(
          initialState.selectedSkuFilters[skuCat]
        );
        newState.appliedSkuFilters[skuCat] = deepCloneObj(
          initialState.appliedSkuFilters[skuCat]
        );
      } else {
        newState.selectedSkuFilters = deepCloneObj(
          initialState.selectedSkuFilters
        );
        newState.appliedSkuFilters = deepCloneObj(
          initialState.appliedSkuFilters
        );
      }
      newState.filtersVisibility = false;
      return newState;

    case actions.GET_FILTERED_SKUS:
      if (action.loadMore) {
        newState.skus = newState.skus.concat(action.skus);
      } else {
        newState.skus = action.skus;
        newState.skusTotalCount = action.totalCount;
        newState.categoryCount = action.categoryCount;
      }
      newState.appliedSearchText = newState.searchText;
      newState.canLoadMoreSkus = action.skus.length === loadMoreSize;
      return newState;

    // RECIPES
    case actions.SELECT_RECIPE_DISHTYPE:
      return Object.assign({}, newState, { selectedDishType: action.dishType });

    case actions.TOGGLE_RECIPE_FILTER:
      let afcr = action.filterCategory;
      if (Array.isArray(selectedRecipeFilters[afcr])) {
        if (selectedRecipeFilters[afcr].includes(action.filter)) {
          selectedRecipeFilters[afcr] = selectedRecipeFilters[afcr].filter(
            (filter) => filter != action.filter
          );
        } else {
          selectedRecipeFilters[afcr].push(action.filter);
        }
      } else {
        selectedRecipeFilters[afcr] =
          selectedRecipeFilters[afcr] === action.filter ? null : action.filter;
      }
      return newState;

    case actions.APPLY_RECIPE_FILTERS:
      newState.appliedRecipeFilters = deepCloneObj(
        newState.selectedRecipeFilters
      );
      newState.filtersVisibility = false;
      return newState;

    case actions.CLEAR_RECIPE_FILTERS:
      const pairCat = action.category;
      if (pairCat !== null) {
        newState.selectedRecipeFilters[pairCat] = deepCloneObj(
          initialState.selectedRecipeFilters[pairCat]
        );
        newState.appliedRecipeFilters[pairCat] = deepCloneObj(
          initialState.appliedRecipeFilters[pairCat]
        );
      } else {
        newState.selectedRecipeFilters = deepCloneObj(
          initialState.selectedRecipeFilters
        );
        newState.appliedRecipeFilters = deepCloneObj(
          initialState.appliedRecipeFilters
        );
      }
      newState.filtersVisibility = false;
      return newState;

    case actions.GET_FILTERED_RECIPES:
      if (action.loadMore) {
        newState.recipes = newState.recipes.concat(action.recipes);
      } else {
        newState.recipes = action.recipes;
        newState.recipesTotalCount = action.totalCount;
        newState.dishTypeCount = action.dishTypeCount;
      }
      newState.appliedSearchText = newState.searchText;
      newState.canLoadMoreRecipes = action.recipes.length === loadMoreSize;
      return newState;

    case actions.OPEN_FILTER_MENU:
      return Object.assign({}, newState, { filtersVisibility: true });

    case actions.UPDATE_SEARCH_TEXT:
      return Object.assign({}, newState, { searchText: action['text'] });

    case actions.CLOSE_FILTER_MENU:
      return Object.assign({}, newState, {
        filtersVisibility: false,
        selectedSkuFilters: deepCloneObj(newState.appliedSkuFilters),
        selectedRecipeFilters: deepCloneObj(newState.appliedRecipeFilters),
      });

    case actions.GET_DIETARY_PREFERENCES:
      return Object.assign({}, newState, {
        dietaryPreferences: action.dietaryPreferences,
      });

    case actions.CHANGE_SORTING:
      return Object.assign({}, newState, { sorting: action.sorting });

    case actions.TOGGLE_ERROR_MODAL:
      return Object.assign({}, newState, { error: action.error });

    case actions.GET_TAGS:
      return Object.assign({}, newState, {
        tagOptions: action.tagOptions,
        tagOptionsOrder: action.tagOptionsOrder,
      });

    case 'RECIPE_FAVORITE_CHANGE':
      return produce(state, (draft) => {
        draft.recipes.forEach((recipe) => {
          if (recipe.id === action.recipeId) {
            recipe.is_favorited = action.isFavorite;
          }
        });
      });

    default:
      return newState;
  }
};

export default filters;
